import { Component, Shark } from "shark-mvc";

import templateContent from "./agent-filter.html";

class AgentFilterComponent extends Component {
	constructor () {
		super("agentFilterComponent");
		this.addTemplate("", templateContent);
	}

	getSelectedAgentGuid () {
		const agentFilter = Shark.get("agentFilter");
		return agentFilter.agentGuid;
	}

	init () {
		let defaultSettings = {
			agentGuid: ""
		};
		let agentFilterComponentSettings = localStorage.getItem("agentFilterComponentSettings");

		if (agentFilterComponentSettings) {
			agentFilterComponentSettings = JSON.parse(agentFilterComponentSettings);
			Object.assign(defaultSettings, agentFilterComponentSettings);
		}

		const agentFilter = Shark.getInstance("__smart__", defaultSettings);

		agentFilter.on("dataChanged", function (data) {
			localStorage.setItem("agentFilterComponentSettings", JSON.stringify(this.export()));

			agentFilterComponent.set({
				__agentFilterStatusCSSClass: this.agentGuid !== "" ? "bg-warning" : "",
			});
		
			//Dave: Schifezza temporanea:
			if ([].indexOf(Shark.activePage.id) === -1 && typeof Shark.activePage.refreshList === "function") {
				Shark.activePage.refreshList();
			}
			else {
				Shark.render();
			}
		});

		this.set({
			__agentFilterStatusCSSClass: agentFilter.agentGuid !== "" ? "bg-warning" : "",
		});
	
		Shark.set({agentFilter});
	}
}

const agentFilterComponent = new AgentFilterComponent();

Shark.registerComponent(agentFilterComponent);

export default agentFilterComponent;
